import { ExchangeResultsState } from "./types";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const state: ExchangeResultsState = {
  items: null,
};

const exchangeResultsModule = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default exchangeResultsModule;
